/**
 * Der gewählte Mandant, gelesen aus dem Browserspeicher.
 *
 * `App.tsx` führt die Wahl als Zustand und legt sie unter diesem Schlüssel ab.
 * Bausteine, die **über** `<App />` hängen — der Drawer tut das, weil er von
 * jeder Ansicht aus geöffnet werden können muss —, kommen an diesen Zustand
 * nicht heran, brauchen den Mandanten aber für ihre eigenen Abrufe.
 *
 * Deshalb hier eine gemeinsame Herleitung statt einer zweiten Kopie des
 * Schlüssels. Sie ist bewusst eine Funktion und keine Konstante: der Wert
 * wechselt zur Laufzeit, wenn jemand den Mandanten umstellt.
 */

import { PROFILE } from './navigation';
import { INSTANZ_MANDANT } from './instanz';

/** Muss mit `MANDANT_SCHLUESSEL` in `App.tsx` übereinstimmen. */
const SCHLUESSEL = 'iammatrix.marke';

/** Vorgabe, solange nichts gewählt wurde — dieselbe wie in `App.tsx`. */
const VORGABE = 'comline';

/**
 * Der Name des Mandanten, wie ihn die Schnittstelle im Kopf `x-mandant`
 * erwartet. Fällt auf COMLINE zurück, wenn der Speicher fehlt oder einen
 * unbekannten Schlüssel führt — ein gesperrter Browserspeicher darf keinen
 * Abruf verhindern.
 */
/**
 * Der **Schluessel** der Marke — `comline`, `howoge`, `dev`.
 *
 * Nicht dasselbe wie `mandantAusSpeicher()`: das liefert den Namen, unter dem
 * die Schnittstelle den Mandanten fuehrt (`HOWOGE`). Hier geht es um die
 * Marke, an der Logo und Farben haengen. Dieselbe Vorrangregel wie dort.
 */
export function markeAusSpeicher(): string {
  if (INSTANZ_MANDANT) return INSTANZ_MANDANT;
  try {
    const s = localStorage.getItem(SCHLUESSEL);
    if (s && PROFILE[s]) return s;
  } catch {
    // Kein Speicher verfuegbar — die Vorgabe bleibt stehen.
  }
  return VORGABE;
}

export function mandantAusSpeicher(): string {
  // Hat die Instanz einen festen Mandanten, gibt es nichts nachzuschlagen —
  // dieselbe Vorrangregel wie in `App.tsx`. Ohne sie zöge der Drawer in einer
  // Kundeninstanz den Mandanten aus einem alten Speichereintrag.
  if (INSTANZ_MANDANT) {
    return PROFILE[INSTANZ_MANDANT]?.name ?? INSTANZ_MANDANT.toUpperCase();
  }
  let schluessel = VORGABE;
  try {
    schluessel = localStorage.getItem(SCHLUESSEL) ?? VORGABE;
  } catch {
    // Kein Speicher verfügbar — die Vorgabe bleibt stehen.
  }
  return (PROFILE[schluessel] ?? PROFILE[VORGABE])?.name ?? 'COMLINE';
}
